import { render } from "./m_brandConcept.vue?vue&type=template&id=205a2f66&scoped=true"
import script from "./m_brandConcept.vue?vue&type=script&lang=js"
export * from "./m_brandConcept.vue?vue&type=script&lang=js"

import "./m_brandConcept.vue?vue&type=style&index=0&id=205a2f66&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205a2f66"]])

export default __exports__